export const branchesActionTypes = {
    SET_VISIBLE_LIST_COMMITS: 'SET_VISIBLE_LIST_COMMITS',
    SET_VISIBLE_CURRENT_VALUE: 'SET_VISIBLE_CURRENT_VALUE'
}
